import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Home } from "lucide-react";

export default function NotFoundPage() {
    return (
        <div className="grid min-h-screen place-items-center bg-background p-6">
            <Card className="w-full max-w-md rounded-2xl border shadow-sm">
                <CardContent className="space-y-4 p-8 text-center">
                    <div className="text-5xl font-bold tracking-tight">404</div>
                    <div className="text-lg font-semibold">Página não encontrada</div>
                    <p className="text-sm text-muted-foreground">
                        A página que você procura não existe ou foi movida.
                    </p>
                    <Button asChild className="bg-secondary text-secondary-foreground hover:opacity-90">
                        <Link to="/dashboard" data-testid="notfound-go-home">
                            <Home className="mr-2 h-4 w-4" /> Voltar para o início
                        </Link>
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
}
